import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './Auth.css';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [resetLink, setResetLink] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL || 'https://stage-reporting-backend.thinkright.ai/api'}/auth/forgot-password`,
                { email }
            );

            if (response.data.success) {
                window.showToast(response.data.message, 'success');
                setResetLink(response.data?.data?.resetLink || '');
                setEmail('');
            }
        } catch (err) {
            window.showToast(
                err.response?.data?.message || 'Failed to send reset email. Please try again.',
                'error'
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-card">
                <h2>Forgot Password</h2>
                <p className="auth-description">
                    Enter your email address and we'll send you a link to reset your password.
                </p>

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="email">Email Address</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            placeholder="Enter your email"
                        />
                    </div>

                    <button type="submit" className="btn-primary" disabled={loading}>
                        {loading ? 'Sending...' : 'Send Reset Link'}
                    </button>
                </form>

                {resetLink && (
                    <div className="success-message" style={{ marginTop: '12px', wordBreak: 'break-all' }}>
                        <strong>Reset Link (Email disabled):</strong><br />
                        <a href={resetLink}>{resetLink}</a>
                    </div>
                )}

                <p className="auth-link">
                    Remember your password? <Link to="/login">Back to Login</Link>
                </p>
            </div>
        </div>
    );
};

export default ForgotPassword;
